"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DestinationType = void 0;
var DestinationType;
(function (DestinationType) {
    // Use this destination if you want the file returned as the
    // response body -- only valid for sync API
    DestinationType["ResponseBody"] = "response-body";
    // Files domain
    DestinationType["File"] = "File";
})(DestinationType = exports.DestinationType || (exports.DestinationType = {}));
//# sourceMappingURL=destination.js.map